import { TextField } from "@mui/material";
import React, { ReactNode } from "react";

type BasicFormProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string | ReactNode;
  isRequired?: boolean;
  placeholder?: string;
};

const BasicForm: React.FC<BasicFormProps> = ({
  label,
  name,
  value,
  onChange,
  error = false,
  helperText = "",
  isRequired = true,
  placeholder = "",
}) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      name={name}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      required={isRequired}
      placeholder={placeholder}
    />
  );
};

export default BasicForm;
